import React, { ReactNode, useEffect, useRef } from 'react';
import styles from './HeaderWrapper.module.scss';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useApplicationUiStore } from '@src/shared/store/ui-store/application-ui-store';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import { isDashboardAllowed } from '@src/shared/utils';
interface componentProps {
  fixed: string | Boolean | undefined;
  children: ReactNode;
}

const HeaderWrapper = ({ fixed, children }: componentProps) => {
  //const isPathDashboard = location.pathname === '/delivery-dashboard';
  const { setAppDomElementClientHeightRef } = useApplicationUiStore();
  const headerRef = useRef<HTMLDivElement>(null);
  const { isAndroid } = useDeviceDetect();
  const { restaurant } = useKeycloakUserState();

  useEffect(() => {
    if (headerRef.current) {
      setAppDomElementClientHeightRef({
        appDomElementNavigationHeader: headerRef.current.clientHeight,
      });
    }
  }, []);

  const wrapperBgColorExists =
    !isDashboardAllowed(restaurant?.country as string) && fixed ? true : false;
  return (
    <div
      ref={headerRef}
      className={`${styles.HeaderWrapper} ${fixed ? styles.fixed : ''} ${
        wrapperBgColorExists ? styles.with_bg_color : ''
      } ${isAndroid ? styles.isAndroid : ''} ${
        isDashboardAllowed(restaurant?.country as string) === true ? styles.dbPath : ''
      }`}
    >
      {children}
    </div>
  );
};

export default HeaderWrapper;
